import React, { createContext, useState, useContext, useEffect } from 'react';
import { getToken } from '../services/authService';
import { setAvailableFeatures, setLimits } from '../services/featureService';
import { getSubscriptionDetails } from '../services/subscriptionService';
import api from '../services/api';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false);

  // Check if user is authenticated on app start
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = getToken();
        if (token) {
          // Get user data using the token and then get+set subscription data
          try {
            const response = await api.get('/auth/me');
            setCurrentUser(response.data);

            // Set available features from the response
            if (response.data.available_features) {
              setAvailableFeatures(response.data.available_features);
            }

            // Get subscription details including limits
            try {
              const subscriptionDetails = await getSubscriptionDetails();
              if (subscriptionDetails.limits) {
                setLimits(subscriptionDetails.limits);
              }
            } catch (error) {
              console.error('Error loading subscription details:', error);
            }

          } catch (error) {
            // If the token is invalid, clear it
            localStorage.removeItem('token');
            setCurrentUser(null);
          }
        } else {
          setCurrentUser(null);
        }
      } catch (error) {
        console.error('Authentication error:', error);
        setCurrentUser(null);
      } finally {
        setIsLoading(false);
        setAuthChecked(true);
      }
    };

    checkAuth();
  }, []);

  return (
    <AppContext.Provider value={{ currentUser, setCurrentUser, isLoading, authChecked }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);